module.exports = __webpack_public_path__ + "img/home-clothing4.7ed5856d.png";